export function StaticsFinal(target: any): void {
	Object.freeze(target);
}

@StaticsFinal
export class WorkflowConstants {
    static readonly MomentFormat = "ddd, MMM DD";
    static readonly UosMaxValue = 999999;
    static readonly UosMinValue = 0;
    static readonly InpatientMaxValue = 999999;
    static readonly InpatientMinValue = 0;
}